import { render, staticRenderFns } from "./ActiveChatList.vue?vue&type=template&id=df63c47c&scoped=true&"
import script from "./ActiveChatList.vue?vue&type=script&lang=ts&"
export * from "./ActiveChatList.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveChatList.vue?vue&type=style&index=0&id=df63c47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df63c47c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VImg,VList,VToolbar})
